import { UserParticipantsCollection as Collection } from '@/typings/api/User'
import { Location } from 'vue-router'
import { PARTICIPANTS_ROUTES as ROUTES } from '@/views/Participants/utils'
import { DELETE } from '@/helpers/enums/table-actions'


export const TABLE_ACTIONS = Object.freeze([
  DELETE,
])

export const TABLE_HEADERS = Object.freeze([

  {
    text: 'ИД',
    value: 'id',
    sortable: false,
  },
  {
    text: 'Имя',
    value: 'name',
    sortable: false,
    getRoute: (data: Collection): Location => ({
      name: ROUTES.VIEW,
      params: { id: data.id.toString() },
    }),
  },
])
